import { FC, useState } from 'react';
import XUIBanner, { XUIBannerActions, XUIBannerMessage } from '@xero/xui/react/banner';
import XUIIcon from '@xero/xui/react/icon';
import warningIcon from '@xero/xui-icon/icons/warning';

export interface IInformationBannerProps {
    header?: JSX.Element;
    action?: JSX.Element;
    bannerMessage: any;
    displayCloseButton?: boolean;
    displayWarningIcon?: boolean;
    qaHook?: string;
    sentiment: 'negative' | 'positive' | 'neutral';
}

const InformationBanner: FC<IInformationBannerProps> = ({
    header,
    action,
    bannerMessage,
    displayCloseButton,
    displayWarningIcon,
    qaHook,
    sentiment,
}) => {
    const [showBanner, setShowBanner] = useState(true);

    const hideBanner = (): void => {
        if (showBanner) {
            setShowBanner(false);
        }
    };

    return showBanner ? (
        <XUIBanner
            qaHook={qaHook}
            sentiment={sentiment}
            onCloseClick={displayCloseButton ? hideBanner : undefined}
            closeButtonLabel='Close'
            className='xui-margin-bottom-2xlarge'
        >
            {header}
            <div className='xui-u-flex xui-u-flex-align-end'>
                <XUIBannerMessage className='xui-u-flex-row xui-u-fullwidth'>
                    {displayWarningIcon ? (
                        <XUIIcon icon={warningIcon} color='black-faint' className='xui-margin-right-small' />
                    ) : null}
                    {bannerMessage}
                </XUIBannerMessage>
                <div className='xui-u-flex-none'>{action && <XUIBannerActions>{action}</XUIBannerActions>}</div>
            </div>
        </XUIBanner>
    ) : null;
};

export default InformationBanner;
